module.exports = __webpack_public_path__ + "img/puzzle9_3.3155be59.jpg";